export default __webpack_public_path__ + "static/media/logo.88e19cb6.svg";